import { z } from "zod";

// What the app is told by the stage it is deployed to, when it runs rather than when it is built, since one build serves
// every stage. `FrontendStack` writes it beside the build; Vite's servers serve none, and the app then runs as it does on
// a stage that tells it nothing. The backend and the frontend share these.

/** Where the app reads what its stage tells it (`appConfigSchema`), beside the build. */
export const appConfigPath = "/config.json";

/** What a stage tells the app. */
export const appConfigSchema = z.object({
	/**
	 * The origin software is told to send the integration API's requests to, the MCP server's included: on a stage with
	 * a domain, the API's own address, `https://api.<zone>`, with no path. Absent on a stage without one, where software
	 * sends them where the app reaches the API. The app itself calls the API where it was built to (`VITE_API_ORIGIN`),
	 * which in every deployed build is its own origin.
	 */
	integrationOrigin: z
		.url({ protocol: /^https$/ })
		// An origin alone: no path, query or fragment — not even a trailing slash — and no user name or password.
		.refine(url => /^[a-z]+:\/\/[^/?#@]+$/.test(url), "Expected an origin alone, such as https://api.dev.ravnar.io")
		.optional(),
});
export type AppConfig = z.infer<typeof appConfigSchema>;
